import { render } from "./CheckoutFullLoader.vue?vue&type=template&id=2ceadfc2"
const script = {}

import "./CheckoutFullLoader.vue?vue&type=style&index=0&id=2ceadfc2&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__